import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { PlaysWrapper } from './SummaryPlays.style';
import SummaryPlayDataContainer  from '../../Play/containers/SummaryPlayDataContainer';

const SummaryPlays = ({
    playArr = [],
    filters,
    openAtBatOverlay,
    parallaxAdIndex
}) => {

    const playArrComps = useMemo(() => {
        return playArr.map((index) => {
            return (
                <SummaryPlayDataContainer
                    key={ `play-${index}` }
                    displayParallaxAd={ index === parallaxAdIndex }
                    filters={ filters }
                    dataIndex={ index }
                    openAtBatOverlay={ openAtBatOverlay }
                />
            );
        });
    }, [playArr, filters, openAtBatOverlay, parallaxAdIndex])

    return (
        <PlaysWrapper>
            { playArrComps }
        </PlaysWrapper>
    );
};

SummaryPlays.propTypes = {
    playArr: PropTypes.arrayOf(PropTypes.number),
    filters: PropTypes.object,
    parallaxAdIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.bool])
};

export default SummaryPlays;
